import { useContext as useContextCore } from 'react'
import { OpenReplayContext } from '../context/OpenReplayContext'

export const useOpenReplay = () => useContextCore(OpenReplayContext)
